import { get } from "lodash-es";
export function isEnableCustomRequest(ctx) {
  const {
    collection,
    cgiInfo
  } = ctx;
  return collection.type === 'frontEndHttp' && get(cgiInfo, 'enableCustomRequest');
}
//# sourceMappingURL=tools.js.map
